import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { WrapperRouter } from './global/routes/WrapperRouter';

import { Amplify } from 'aws-amplify';
import { signOut } from '@aws-amplify/auth';
import awsconfig from 'aws-config';
Amplify.configure(awsconfig, {
    ssr:true
});

const COGNITO_PREFIX = `CognitoIdentityServiceProvider.${process.env.REACT_APP_COGNITO_CLIENT_ID}`;
//CognitoIdentityServiceProvider.3847atoqrs3jd7a6tosqsp0ia4
const staleKeys = Object.keys(localStorage).filter((k) => 
  k.startsWith(COGNITO_PREFIX)
);

if (staleKeys.length > 0) {
  console.log(JSON.stringify(staleKeys));
  staleKeys.forEach((k) => localStorage.removeItem(k));
  localStorage.removeItem("user");
  signOut({ global: true }).finally(() => {
    // Redirect to the login page after session cleanup
    window.location.replace('/login');
    alert("La sesión ha caducado, por favor vuelve a ingresar con su correo y contraseña");
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <WrapperRouter />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
